import { StyleSheet } from 'react-native'
import theme from '../../../theme'

const styles = StyleSheet.create({
    container: {
        paddingVertical: 10,
    },
    input: {
        height: 40,
        borderWidth: 0.5,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        paddingVertical: 10,
        paddingHorizontal: 10,
        marginHorizontal: 10,
        alignItems: 'center',
        color: theme.colors.textPrimary,
    },
    dropdown: {
        borderWidth: 0.5,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        color: theme.colors.lightGray,
        marginHorizontal: 10,
    },
    dropdownOptions: {
        color: theme.colors.textPrimary,
    },
    dropdownInput: {
        color: theme.colors.textPrimary,
    },
    titles: {
        fontSize: 15,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        marginBottom: 10,
    },
    tagInput: {
        fontSize: 14,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        padding: 10,
    },
    buttonContainer: {
        flexDirection: 'column',
        paddingVertical: 15,
        bottom: 15,
        width: '100%',
    },
    mainButton: {
        marginTop: 10,
        backgroundColor: theme.colors.colorPrimary,
        padding: 10,
        borderRadius: 10,
        marginHorizontal: 10,
    },
    mainButtonText: {
        fontSize: 16,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    containerFeedback: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 15,
        marginHorizontal: 15,
    },
    image: {
        width: 140,
        height: 140,
    },
    title: {
        fontSize: 20,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 6,
    },
    description: {
        fontSize: 17,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        lineHeight: 25,
    },
})

export default styles
